import { forwardRef, useEffect, useRef } from 'react';
import { safeHTML } from '../../../utils/safeHTML';
import { useShowMessage } from '../../../redux/reducer/content';
import { CSSTransition } from 'react-transition-group';
import { useApplicationCallbacks } from '../../../providers/application-callbacks';

const CopyMessage = forwardRef(function (_, ref) {
  const showMessage = useShowMessage();
  const timeoutRef = useRef();

  const appCallbacks = useApplicationCallbacks();

  useEffect(() => {
    if (showMessage) {
      timeoutRef.current = setTimeout(() => {
        appCallbacks.setShowMessage(null);
        timeoutRef.current = null;
      }, 3000);

      return () => {
        clearTimeout(timeoutRef.current);
        timeoutRef.current = null;
      };
    }
  }, [showMessage]);

  return (
    <CSSTransition in={showMessage} timeout={300} mountOnEnter unmountOnExit classNames={'copy-message'}>
      <div className={'copy-message'} ref={ref}>
        {safeHTML(showMessage)}
      </div>
    </CSSTransition>
  );
});

export default CopyMessage;
